import httpClient from "./httpClient";

const ZoneService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/zone", {
      params: { page, pageSize }
    });
  },

  async getAll() {
    return await httpClient.get("/zone/get-all");
  },

  async findById(id) {
    return await httpClient.get(`/zone/${id}`);
  },

  async create(entity) {
    return await httpClient.post("/zone", entity);
  },

  async update(entity) {
    return await httpClient.put("/zone", entity);
  }
};

export default ZoneService;
